import { render, staticRenderFns } from "./ChooseTab.vue?vue&type=template&id=2f71f054&scoped=true&"
import script from "./ChooseTab.vue?vue&type=script&lang=js&"
export * from "./ChooseTab.vue?vue&type=script&lang=js&"
import style0 from "./ChooseTab.vue?vue&type=style&index=0&id=2f71f054&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f71f054",
  null
  
)

export default component.exports